import { WeightUnit } from '@src/util/weight'

export default class {

  id: number
  name: string
  // exercise execution (seconds)
  screenExerciseLen: number
  // exercise preparation (seconds)
  screenCountdownLen: number
  // results screen (seconds)
  screenSummaryLen: number
  displayPixScore: boolean
  banner: string
  category: string
  addressCountry: string
  addressLine1: string
  addressLine2: string
  addressLine3: string
  addressPostcode: string
  addressTownCity: string
  circleExerciseDuration: number
  clubId: string
  defaultLocale: string
  facebookPage: string
  stationLayout: string
  timezone: string
  weightUnit: WeightUnit
  workoutTimeoutSecs: number
  enableTanitaAppUsage: boolean
  showUserStats: boolean
  sundayShutdownTime: string
  mondayShutdownTime: string
  tuesdayShutdownTime: string
  wednesdayShutdownTime: string
  thursdayShutdownTime: string
  fridayShutdownTime: string
  saturdayShutdownTime: string
  sundayBootTime: string
  mondayBootTime: string
  tuesdayBootTime: string
  wednesdayBootTime: string
  thursdayBootTime: string
  fridayBootTime: string
  saturdayBootTime: string
  enableShutdownTime: boolean
  isBrandMaster: boolean
  createdAt: string
  updatedAt: string
  brandColorHex: string
  brandName: string
  masterClub: boolean
  showClasses: boolean
  smileyId: number
  audioHintsAvailable: boolean

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}
